module.exports = __webpack_public_path__ + "img/selected3-min.248e44b9.png";